import { Menu, X } from 'lucide-react';
import { IonRouterLink } from '@ionic/react';
import { useEffect, useState } from 'react';

import { LoadingButton } from './ui/loading-button'; // Import your LoadingButton component
import { useTranslation } from 'react-i18next';

const LandingNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [loadingSignIn, setLoadingSignIn] = useState(false); // Loading state for Sign In
  const [loadingSignUp, setLoadingSignUp] = useState(false); // Loading state for Sign Up

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      setIsScrolled(() => {
        const newState = scrollPosition > window.innerHeight;
        return newState;
      });
    };

    // Add initial check
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSignInClick = () => {
    setLoadingSignIn(true);
    // Simulate navigation or async operation
    setTimeout(() => {
      window.location.href = '/sign-in'; // Redirect to sign-in
    }, 1000); // Adjust delay as needed
  };

  const handleSignUpClick = () => {
    setLoadingSignUp(true);
    // Simulate navigation or async operation
    setTimeout(() => {
      window.location.href = '/sign-up'; // Redirect to sign-up
    }, 1000); // Adjust delay as needed
  };

  return (
    <nav
      className={`inset-x-0 top-0 z-[60] mx-auto w-full bg-transparent backdrop-blur-[10px] transition-all duration-300 lg:px-40 ${isScrolled ? 'hidden' : 'fixed'
        }`}
    >
      <div className="relative flex items-center justify-between px-4 py-2">
        {/* Logo */}
        <div className="relative z-20 flex items-center space-x-2 px-2 py-1 font-normal text-white">
          <img alt="logo" height={32} width={32} src="../favicon.svg" />
          <span className="hidden font-bold md:block">FACE.GOLF</span>
          <span className="block font-bold md:hidden">MGP</span>
        </div>

        {/* Mobile Menu */}
        <div
          className={`absolute inset-x-0 top-full mt-2 w-full rounded-lg bg-neutral-800 p-4 text-white shadow-lg md:static md:mt-0 md:flex md:w-auto md:items-start md:bg-transparent md:p-0 md:shadow-none ${isMenuOpen ? 'block' : 'hidden'
            }`}
        >
          <div className="flex flex-col space-y-2 md:flex-row md:space-x-4 md:space-y-0">
            <IonRouterLink
              href="#"
              className="group relative px-4 py-2 text-white transition-colors hover:text-white"
            >
              <span className="relative z-20">Features</span>
              <span className="absolute inset-0 scale-75 rounded-full bg-neutral-700 opacity-0 transition-all duration-200 group-hover:scale-100 group-hover:opacity-100" />
            </IonRouterLink>
            <IonRouterLink
              href="#"
              className="group relative px-4 py-2 text-white transition-colors hover:text-white"
            >
              <span className="relative z-20">Pricing</span>
              <span className="absolute inset-0 scale-75 rounded-full bg-neutral-700 opacity-0 transition-all duration-200 group-hover:scale-100 group-hover:opacity-100" />
            </IonRouterLink>
            <IonRouterLink
              href="#"
              className="group relative px-4 py-2 text-white transition-colors hover:text-white"
            >
              <span className="relative z-20">Contact</span>
              <span className="absolute inset-0 scale-75 rounded-full bg-neutral-700 opacity-0 duration-200 group-hover:scale-100 group-hover:opacity-100" />
            </IonRouterLink>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex items-center space-x-4">
          <LoadingButton
            onClick={handleSignInClick}
            loading={loadingSignIn}
            type="button"
            className="rounded-full bg-white px-4 py-2 text-center text-black hover:bg-white/50"
          >
            {t('signin')}
          </LoadingButton>
          <LoadingButton
            onClick={handleSignUpClick}
            loading={loadingSignUp}
            type="button"
            className="rounded bg-primary/50 px-4 py-2 text-center text-white hover:bg-primary/40"
          >
            {t('signup')}
          </LoadingButton>

          {/* Menu Toggle Button */}
          <button
            type="button"
            className="rounded px-2 py-1 text-muted-foreground hover:text-white focus:outline-none md:hidden"
            onClick={toggleMenu}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;
